import React from 'react';
import { getDeviceType } from 'js/utils/deviceDetection';

// imports
import AnimationBalloon from 'js/components/animations/Animation.balloon';
import AnimationBluey from 'js/components/animations/Animation.bluey';

// import scaler
import ScaleContainer from 'js/scale/Scale.container';

const ContainerBalloonAnimation = ({ popcornAnimationComplete = true }) => {
  const desktop = getDeviceType() === 'desktop';

  return (
    <div id="animation-container" style={{ height: '100%', position: 'relative', overflow: 'hidden' }}>
      {desktop ? (
        <ScaleContainer hPosition="center">
          <AnimationBalloon popcornAnimationComplete={popcornAnimationComplete} />
          {popcornAnimationComplete && <AnimationBluey />}
        </ScaleContainer>
      ) : (
        <>
          <AnimationBalloon popcornAnimationComplete={popcornAnimationComplete} />
          {popcornAnimationComplete && <AnimationBluey />}
        </>
      )}
    </div>
  );
};

export default ContainerBalloonAnimation;
